import React from 'react';
import { Route, Switch, match, Redirect } from 'react-router-dom';

import Overview from 'pages/Entity/Track/Overview/index';
import VersionOverview from 'pages/Entity/Track/Version/Overview';
import Performance from 'pages/Entity/Track/Performance/index';
import VersionPerformance from 'pages/Entity/Track/Version/Performance';
import Territory from 'pages/Entity/Track/Shared/Territory';
import Charts from 'pages/Entity/Track/Charts/index';
import VersionCharts from 'pages/Entity/Track/Version/Charts';
import Airplay from 'pages/Entity/Track/Airplay/index';
import VersionAirplay from 'pages/Entity/Track/Version/Airplay';
import Social from 'pages/Entity/Track/Social/index';
import VersionSocial from './Track/Version/Social';
import Audience from 'pages/Audience';

interface ITrackParams {
  entityId: string;
}

interface ITrackProps {
  location: any;
  match: match<ITrackParams>;
  pathPrefix: string;
  loading: boolean;
  artistMetadata: any;
}

const Track: React.FC<ITrackProps> = (props) => {
  const { location, pathPrefix, loading, artistMetadata } = props;

  return (
    <Switch location={location}>
      <Route
        path={`${pathPrefix}/track/:entityId/overview`}
        render={(routerProps: any): any => (
          <Overview
            {...routerProps}
            isEntityLoading={loading}
            pathPrefix={pathPrefix}
            artistMetadata={artistMetadata}
          />
        )}
      />
      <Route
        path={`${pathPrefix}/track/:parentEntityId/version/:entityId/overview`}
        render={(routerProps: any): any => (
          <VersionOverview
            {...routerProps}
            isEntityLoading={loading}
            pathPrefix={pathPrefix}
            artistMetadata={artistMetadata}
          />
        )}
      />
      <Route
        path={`${pathPrefix}/track/:entityId/performance`}
        render={(routerProps: any): any => (
          <Performance {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/track/:parentEntityId/version/:entityId/performance`}
        render={(routerProps: any): any => (
          <VersionPerformance {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/track/:parentEntityId/version/:entityId/airplay`}
        render={(routerProps: any): any => (
          <VersionAirplay {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/track/:entityId/airplay`}
        render={(routerProps: any): any => (
          <Airplay {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/track/:entityId/charts`}
        render={(routerProps: any): any => (
          <Charts {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/track/:parentEntityId/version/:entityId/charts`}
        render={(routerProps: any): any => (
          <VersionCharts {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      {/* Social */}
      <Route
        path={`${pathPrefix}/track/:parentEntityId/version/:entityId/social`}
        render={(routerProps: any): any => (
          <VersionSocial {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/track/:entityId/social`}
        render={(routerProps: any): any => (
          <Social {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        exact
        path={`${pathPrefix}/track/:entityId/audience/ageGender`}
        render={(routerProps: any): any => <Audience {...routerProps} />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/:parentEntityId/version/:entityId/audience/ageGender`}
        render={(routerProps: any): any => <Audience {...routerProps} />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/:entityId/audience/territory`}
        render={(routerProps: any): any => <Territory {...routerProps} />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/:parentEntityId/version/:entityId/audience/territory`}
        render={(routerProps: any): any => <Territory {...routerProps} />}
      />
      {/*<Redirect*/}
      {/*  path={`${pathPrefix}/track/:entityId/audience/ageGender`}*/}
      {/*  to={`${pathPrefix}/track/:entityId/audience/territory`}*/}
      {/*/>*/}
      <Redirect
        exact
        from={`${pathPrefix}/track/:entityId/audience`}
        to={`${pathPrefix}/track/:entityId/audience/ageGender`}
      />
      {/*<Redirect*/}
      {/*  path={`${pathPrefix}/track/:parentEntityId/version/:entityId/ageGender`}*/}
      {/*  to={`${pathPrefix}/track/:parentEntityId/version/:entityId/audience/territory`}*/}
      {/*/>*/}
      <Redirect
        exact
        from={`${pathPrefix}/track/:parentEntityId/version/:entityId/audience`}
        to={`${pathPrefix}/track/:parentEntityId/version/:entityId/audience/ageGender`}
      />
    </Switch>
  );
};

export default Track;
